/**
 * ブログ記事 検索・カテゴリフィルター
 */
(function() {
  'use strict';

  const searchInput = document.getElementById('blog-search-input');
  const searchClear = document.getElementById('blog-search-clear');
  const categoryButtons = document.querySelectorAll('.blog-category-btn');
  const articlesGrid = document.getElementById('blog-articles-grid');
  const filterMessage = document.getElementById('blog-filter-message');

  if (!searchInput || !articlesGrid) return;

  let currentCategory = 'all';
  let currentSearchTerm = '';

  /**
   * 記事をフィルタリング
   */
  function filterArticles() {
    const articles = articlesGrid.querySelectorAll('.blog-article-card');
    let visibleCount = 0;

    articles.forEach(function(article) {
      const tags = (article.dataset.tags || '').toLowerCase();
      const searchText = (article.dataset.searchText || '').toLowerCase();
      const searchTerm = currentSearchTerm.toLowerCase().trim();

      // カテゴリフィルター判定
      let categoryMatch = currentCategory === 'all';
      if (!categoryMatch) {
        const tagArray = tags.split(',').map(function(t) { return t.trim(); });
        categoryMatch = tagArray.some(function(tag) {
          return tag === currentCategory.toLowerCase();
        });
      }

      // 検索フィルター判定
      let searchMatch = searchTerm === '';
      if (!searchMatch) {
        searchMatch = searchText.indexOf(searchTerm) !== -1;
      }

      // 表示/非表示
      if (categoryMatch && searchMatch) {
        article.style.display = '';
        visibleCount++;
      } else {
        article.style.display = 'none';
      }
    });

    // 結果なしメッセージ
    if (filterMessage) {
      filterMessage.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    // クリアボタンの表示
    if (searchClear) {
      searchClear.style.display = currentSearchTerm ? 'flex' : 'none';
    }
  }

  /**
   * カテゴリボタンのクリックハンドラ
   */
  function handleCategoryClick(e) {
    const btn = e.currentTarget;
    currentCategory = btn.dataset.category || 'all';

    // アクティブ状態の更新
    categoryButtons.forEach(function(b) {
      b.classList.remove('active');
    });
    btn.classList.add('active');

    filterArticles();
  }

  /**
   * 検索入力のハンドラ
   */
  function handleSearchInput(e) {
    currentSearchTerm = e.target.value;
    filterArticles();
  }

  /**
   * 検索クリアのハンドラ
   */
  function handleSearchClear() {
    searchInput.value = '';
    currentSearchTerm = '';
    filterArticles();
    searchInput.focus();
  }

  // イベントリスナー設定
  categoryButtons.forEach(function(btn) {
    btn.addEventListener('click', handleCategoryClick);
  });

  searchInput.addEventListener('input', handleSearchInput);

  if (searchClear) {
    searchClear.addEventListener('click', handleSearchClear);
  }

  // Enterキーでフォーム送信を防止
  searchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  });

  // 初期状態でクリアボタンを非表示
  if (searchClear) {
    searchClear.style.display = 'none';
  }
})();
